<div
  class="landing"
  *transloco="let t">
  <div class="register-user-new">
    <div class="register-user-new_form">
      <app-company-logo [width]="200" />
      <div class="register-user-new_inner">
        <div>
          <h2 class="register-user-new_title">
            {{ registrationPageBrandingTexts()?.headingText || t('registration-new.title') }}
          </h2>
        </div>
        <form
          class="register-user-new_request-email-form"
          [formGroup]="invitationEmailForm"
          (ngSubmit)="requestRegistrationEmail()"
          novalidate>
          <div class="register-user-new_email form-group">
            <div class="form-control-labelled">
              <input
                type="email"
                class="form-control"
                [class.is-invalid]="(emailControl.invalid && highlightErrors()) || isInvalidDomain()"
                [class.ng-not-empty]="emailControl.value.length"
                autocomplete="off"
                id="requestInvitationEmail"
                name="email"
                formControlName="email" />
              <label
                class="form-control-labelled_label__no-star"
                for="requestInvitationEmail">
                {{ t('registration-new.email') }}
              </label>
            </div>
            <div
              class="message __error text-xsmall"
              role="alert">
              @if (emailControl.invalid && highlightErrors()) {
                @if (emailControl.errors.required) {
                  {{ t('common.enter-email') }}
                }
                @if (emailControl.errors.fbInvalidEmail) {
                  {{ t('common.enter-valid-email') }}
                }
                @if (emailControl.errors.userExists) {
                  {{ t('registration-new.error.user-exists') }}
                }
                @if (emailControl.errors.registrationFailed) {
                  {{ t('registration-new.error.registration-failed') }}
                }
                @if (emailControl.errors.emailDisallowed) {
                  {{ t('registration-new.error.email-disallowed') }}
                }
                @if (emailControl.errors.serviceUnavailable) {
                  {{ t('api-error.0999') }}
                }
              }
              @if (isInvalidDomain()) {
                <div
                  [innerHTML]="
                    t('registration.user.invalid-domain', {
                      validDomains: allowedDomainsAsList(registrationLink().domains)
                    })
                  "></div>
              }
            </div>
          </div>
          <div class="form-group">
            <button
              class="btn register-user-new_button"
              type="submit"
              [disabled]="isInProgress()"
              ngPreserveWhitespaces>
              {{ t('registration-new.sign-up') }}
              @if (isInProgress()) {
                <ic-loading-indicator [size]="18" />
              }
            </button>
          </div>
        </form>
        @if (hasSsoEnabled()) {
          <div class="register-user-new_divider">
            {{ t('registration-new.or') }}
          </div>
          <button
            type="button"
            class="btn register-user-new_button register-user-new_button-outline"
            (click)="redirectToSSO()">
            {{ t('registration-new.sso') }}
          </button>
        }
        <div class="register-user-new_footnote-center">
          {{ t('auth.login.have-account') }}
          <a [href]="loginUrl()">
            {{ t('registration-new.log-in') }}
          </a>
        </div>
      </div>
      <div class="layout_footer">
        <app-legal-terms-footer />
      </div>
    </div>
    <div appBackgroundBranded></div>
  </div>
</div>
